import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dropdownMenuItem } from "@air/primitive-dropdown-menu";
import { Switch } from "@air/primitive-switch";
import { memo } from "react";
import { VISIBILITY_TOGGLE_HEADER, VISIBILITY_TOGGLE_SWITCH } from "~/constants/testIDs";
export const ViewVisibilityHeaderToggle = /*#__PURE__*/ memo((param)=>{
    let { id, label, onToggle, isToggleOn } = param;
    return /*#__PURE__*/ _jsxs("button", {
        className: dropdownMenuItem({
            size: "small",
            className: "w-full"
        }),
        "data-testid": "".concat(VISIBILITY_TOGGLE_HEADER, "-").concat(id),
        "data-id": id,
        onClick: onToggle,
        type: "button",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex min-w-0 grow truncate text-14",
                children: label
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-2 shrink-0",
                children: /*#__PURE__*/ _jsx(Switch, {
                    "aria-readonly": true,
                    checked: isToggleOn,
                    "data-id": id,
                    "data-testid": VISIBILITY_TOGGLE_SWITCH,
                    id: id,
                    name: id
                })
            })
        ]
    });
});
ViewVisibilityHeaderToggle.displayName = "ViewVisibilityHeaderToggle";
